import { forwardRef as l } from "react";
import { useThemeUI as n } from "theme-ui";
import * as r from "@radix-ui/react-dialog";
import { Cross24Icon as e, Cross32Icon as p } from "@material-bank/mb-icons";
import { useResponsiveValue as d } from "../../../lib/css/css-hooks.js";
import "../../../lib/css/match-media-context.js";
import "@theme-ui/css";
import { jsxs as c, Fragment as f, jsx as o } from "theme-ui/jsx-runtime";
import { IconButton as x } from "../../Button/IconButton/IconButton.js";
import "@material-bank/ds-utils";
import { Text as h } from "../../Typography/Text.js";
const u = l(({
  children: i,
  displayCloseButton: t = !0
}, m) => {
  const {
    theme: s
  } = n(), a = d([e, p]) ?? e;
  return /* @__PURE__ */ c(f, {
    children: [t && /* @__PURE__ */ o(r.Close, {
      asChild: !0,
      children: /* @__PURE__ */ o(x, {
        icon: /* @__PURE__ */ o(a, {
          sx: {
            color: "primary"
          }
        }),
        size: "md",
        sx: {
          position: "absolute",
          right: 4,
          top: 4
        },
        variant: "white"
      })
    }), /* @__PURE__ */ o(r.Title, {
      asChild: !0,
      ref: m,
      sx: {
        ...s.dialogHeader.modal,
        px: [4, 8]
      },
      children: /* @__PURE__ */ o(h, {
        sx: {
          maxWidth: "90%"
        },
        variant: "title4",
        children: i
      })
    })]
  });
});
u.displayName = "DialogHeader";
export {
  u as DialogHeader
};
